<div class="dashboard">

  <!-- En-tête ─────────────────────────────────────────────────────────────── -->
  <div class="dash-header">
    <div>
      <h1 class="dash-title">Tableau de bord</h1>
      <p class="dash-subtitle">{{ today }}</p>
    </div>
  </div>

  @if (loading()) {
    <div class="loading"><p-progressSpinner styleClass="spinner-sm" strokeWidth="4" /></div>
  } @else {

    <!-- KPI cards ──────────────────────────────────────────────────────────── -->
    <div class="kpi-grid">

      <div class="kpi-card kpi-orange" routerLink="/properties">
        <div class="kpi-top">
          <span class="kpi-label">Biens en attente</span>
          <div class="kpi-icon-wrap kpi-icon-orange"><i class="pi pi-building"></i></div>
        </div>
        <div class="kpi-value">{{ pendingProperties() }}</div>
        <div class="kpi-footer"><i class="pi pi-arrow-right"></i><span>Voir les biens</span></div>
      </div>

      <div class="kpi-card kpi-blue" routerLink="/back-office/documents">
        <div class="kpi-top">
          <span class="kpi-label">Documents en attente</span>
          <div class="kpi-icon-wrap kpi-icon-blue"><i class="pi pi-file"></i></div>
        </div>
        <div class="kpi-value">{{ pendingDocuments() }}</div>
        <div class="kpi-footer"><i class="pi pi-arrow-right"></i><span>Voir les documents</span></div>
      </div>

      <div class="kpi-card kpi-green" routerLink="/plans">
        <div class="kpi-top">
          <span class="kpi-label">Plans actifs</span>
          <div class="kpi-icon-wrap kpi-icon-green"><i class="pi pi-crown"></i></div>
        </div>
        <div class="kpi-value">{{ plansCount() }}</div>
        <div class="kpi-footer"><i class="pi pi-arrow-right"></i><span>Gérer les plans</span></div>
      </div>

      <div class="kpi-card kpi-purple" routerLink="/properties">
        <div class="kpi-top">
          <span class="kpi-label">Total des biens</span>
          <div class="kpi-icon-wrap kpi-icon-purple"><i class="pi pi-chart-bar"></i></div>
        </div>
        <div class="kpi-value">{{ totalProperties() }}</div>
        <div class="kpi-footer"><i class="pi pi-arrow-right"></i><span>Tous les biens</span></div>
      </div>

    </div>

    <!-- Graphiques ─────────────────────────────────────────────────────────── -->
    <div class="charts-grid">
      <p-card styleClass="chart-card">
        <ng-template #title>
          <div class="chart-title"><i class="pi pi-chart-pie"></i> Biens par statut</div>
          <p class="chart-sub">Répartition sur un échantillon de {{ snapshotCount() }} bien{{ snapshotCount() > 1 ? 's' : '' }}</p>
        </ng-template>
        <ng-template #content>
          @if (statusChartData) {
            <div class="chart-box">
              <p-chart type="doughnut" [data]="statusChartData" [options]="statusChartOptions" height="260px" />
            </div>
          }
        </ng-template>
      </p-card>

      <p-card styleClass="chart-card">
        <ng-template #title>
          <div class="chart-title"><i class="pi pi-chart-bar"></i> Biens par type</div>
          <p class="chart-sub">Répartition sur le même échantillon</p>
        </ng-template>
        <ng-template #content>
          @if (typeChartData) {
            <div class="chart-box">
              <p-chart type="bar" [data]="typeChartData" [options]="typeChartOptions" height="260px" />
            </div>
          }
        </ng-template>
      </p-card>
    </div>

    <!-- Accès rapides ───────────────────────────────────────────────────────── -->
    <div class="quick-section">
      <h2 class="section-title">Accès rapides</h2>
      <div class="quick-grid">
        <a class="quick-item" routerLink="/properties">
          <i class="pi pi-check-square"></i>
          <span>Valider des biens</span>
        </a>
        <a class="quick-item" routerLink="/back-office/documents">
          <i class="pi pi-file-check"></i>
          <span>Traiter des documents</span>
        </a>
        <a class="quick-item" routerLink="/plans/new">
          <i class="pi pi-plus-circle"></i>
          <span>Créer un plan</span>
        </a>
        <a class="quick-item" routerLink="/plans">
          <i class="pi pi-list"></i>
          <span>Voir tous les plans</span>
        </a>
      </div>
    </div>

    <!-- Biens récents ───────────────────────────────────────────────────────── -->
    @if (recentProperties().length > 0) {
      <div class="table-section">
        <div class="section-header">
          <h2 class="section-title">Biens récents à valider</h2>
          <a pButton [text]="true" routerLink="/properties" class="see-all-btn" icon="pi pi-arrow-right" iconPos="right" label="Voir tout"></a>
        </div>

        <p-table [value]="recentProperties()" styleClass="recent-table" [rowHover]="true">
          <ng-template #header>
            <tr>
              <th>Titre</th>
              <th>Ville</th>
              <th>Type</th>
              <th>Statut</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template #body let-p>
            <tr>
              <td class="cell-title">{{ p.title }}</td>
              <td>
                <span class="cell-city"><i class="pi pi-map-marker"></i>{{ p.city ?? '—' }}</span>
              </td>
              <td><span class="chip-type">{{ typeLabel(p.type) }}</span></td>
              <td><p-tag value="En attente" severity="warn" [rounded]="true" /></td>
              <td class="cell-action">
                <a pButton [text]="true" [rounded]="true" icon="pi pi-external-link"
                   [routerLink]="['/properties', p.id]" pTooltip="Consulter"></a>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }

  }
</div>
